module.exports = __webpack_public_path__ + "img/savingnotes-ar.d59366d8.png";